import { useMutation } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * tRPC variant of step 1 of the Slack OAuth connect (COI-709): asks the server
 * for a signed `state` to put in the Slack authorize URL. `useSlack` picks
 * between this and the legacy `POST /slack/begin-connect` on the `trpc` flag.
 *
 * The browser used to generate this nonce itself, which the server never saw —
 * so it could not tell a callback the user really started from one an attacker
 * planted. Nothing is invalidated on success: minting reads and writes no
 * server state the UI shows.
 */
export const useBeginConnectSlackTRPC = () => {
  const trpc = useTRPC();
  const mutation = useMutation(
    trpc.frontend.notifications.slack.beginConnect.mutationOptions()
  );

  // Only the mutate fn is exposed, matching `useConnectSlackTRPC`: the sole
  // caller (`useSlack`) drives its own error surface.
  return {
    beginConnectSlack: async (): Promise<string> => {
      const { state } = await mutation.mutateAsync();

      return state;
    },
  };
};
